import React from 'react';
import { Label } from '@rebass/forms';

/**
 * Renders the attachment links under one email in the participant communication history.
 *
 * Always give this `downloadable_attachments`, never the raw `attachments` column: the
 * api rebuilds the download URL in that accessor, and the stored `filepath` of anything
 * received before PFOX-1411 has the S3 key concatenated into `?path=` unencoded — a
 * filename containing `&` or `#` ends the query string there and the link 404s.
 *
 * @param {Object} props props
 * @param {Array<{filename: string, filepath: string}>} [props.attachments] the email's downloadable_attachments
 * @returns {React.ReactNode} EmailAttachmentList component, or null when there is nothing to list
 */
export function EmailAttachmentList({ attachments }) {
    // An email predating the accessor, or a payload from a cached page load, can arrive
    // without the field at all - an absent attachment list is not an error worth a crash.
    if (!Array.isArray(attachments) || attachments.length === 0) return null;

    const listable = attachments.filter(attachment => attachment.filepath && attachment.filename);

    if (listable.length === 0) return null;

    return (
        <div className="email-attachments">
            <Label className="quiet fs-12">Attachments</Label>
            {listable.map(attachment => (
                <div className="ellipsis" key={attachment.filepath}>
                    &bull;{' '}
                    <a href={attachment.filepath} target="_blank">
                        {attachment.filename}
                    </a>
                </div>
            ))}
        </div>
    );
}

export default EmailAttachmentList;
